import React, { Component } from 'react'
import PropTypes from 'prop-types'

// CSS
import './WorkDetailImage.css'

class WorkDetailImage extends Component {

  constructor(props) {
    super(props)
    this.state = { 
      imageStatus: 'loading' 
    }
  }

  static propTypes = {
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  }
 
  handleImageLoaded = () => {
    this.setState({ imageStatus: 'loaded' });
  }
 
  handleImageErrored = () => {
    this.setState({ imageStatus: 'failed' });
  }

  render() {

    return (
      <div className="project-image">
        {this.renderCurrentImageStatus()}
        <img 
          src={this.props.image} 
          onLoad={this.handleImageLoaded}
          onError={this.handleImageErrored}
          alt={this.props.title}
        />
        <span className="project-image-title">{this.props.title}</span>
      </div>
    )

  }

  renderCurrentImageStatus = () => {
    if(this.state.imageStatus === "loading") {
      return <div>Loading</div>
    } else if (this.state.imageStatus === "failed") {
      return <div>Failed to load image</div>
    } else {
      return null
    }
  }

}

export default WorkDetailImage;



// WEBPACK FOOTER //
// ./src/components/main/work/workdetails/workdetailimage/WorkDetailImage.js